// Small badge showing the build the kiosk is actively running, so staff can
// glance at a device and know its version. The value is injected at build time
// (release tag in production, merge-commit SHA in staging); empty in local dev.

const version = (import.meta.env.VITE_APP_VERSION as string) || "";

// Semver tags show as-is; long commit SHAs (staging) are truncated to 7 chars.
function label(v: string): string {
  if (!v) return "dev";
  return v.length > 12 ? v.slice(0, 7) : v;
}

export function VersionBadge() {
  return (
    <span
      aria-label="App version"
      className="select-none rounded-full bg-gray-100 px-2 py-0.5 font-mono text-xs leading-none text-gray-500"
    >
      {label(version)}
    </span>
  );
}
